import React from "react"
import ReactMarkdown from 'react-markdown'
import Breaks from 'remark-breaks'

export default class Markdown extends React.Component {
  render() {
    return (
      <ReactMarkdown {... this.props} plugins={[Breaks]} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Markdown/index.js